import React from 'react';
import { Router, Route, Link, hashHistory } from 'react-router';

import RefreshIndicator from '../components/refreshIndicator.jsx';
import Avatar from 'material-ui/Avatar';

const Leaderboard = React.createClass({
	_viewScore: function(user) {
		this.props.switchScoreSheet(user);
	},
	_getQuiz: function() {
		this.props.getQuiz(this.props.id);
	},
	_getPlayerResult: function() {
		const style = {
			avatar: {
				height: '60px',
				width: '60px',
				marginRight: '1em',
				flex: '0 0 auto',
				backgroundColor: 'transparent',
			}
		}
		return this.props.results.map((player) => {
			if (player.username == localStorage.getItem('username')) {
				return (
					<div className="me result"
						key={player.username}
						onClick={() => this._viewScore(player.username)}
					>
						<div className="rank">{player.rank}</div>
						<Avatar src={'/images/avatars/full/' + player.avatar + '.png'} style={style.avatar} />
						<div className="username">{player.username}</div>
						<div className="score">{player.score}</div>
					</div>
				)
			} else {
				return (
					<div className="result"
						key={player.username}
						onClick={() => this._viewScore(player.username)}
					>
						<div className="rank">{player.rank}</div>
						<Avatar src={'/images/avatars/full/' + player.avatar + '.png'} style={style.avatar} />
						<div className="username">{player.username}</div>
						<div className="score">{player.score}</div>
					</div>
				)
			}
		});
	},
	render: function() {
		const results = this._getPlayerResult();
		return (
			<div className="results">
				<RefreshIndicator
					viewClass="results"
					request={this._getQuiz}
				/>
				{results}
			</div>
		)
	}
});

export default Leaderboard;


// WEBPACK FOOTER //
// ./src/views/leaderboard.jsx